import { useEffect } from "react";
import { SEO_TITLE, SEO_DESC, APPLY_EMAIL } from "@/components/job/jobData";
import { usePageSEO, setJsonLd, SITE_URL } from "@/hooks/useCanonical";
import { BRAND } from "@/lib/constants";

const JOB_PATH = "/vagas/enfermeiro-adm-emq";

const jobPostingSchema = {
  "@context": "https://schema.org",
  "@type": "JobPosting",
  title: "Enfermeiro(a) Administrativo — Entrevista Médica Qualificada",
  description:
    "A Previsa Saúde busca Enfermeiro(a) Administrativo para atuar com Entrevista Médica Qualificada, análise técnica de informações de saúde, apoio ao preenchimento da Declaração de Saúde (DS), elaboração de relatórios técnicos e auditoria em saúde. Requisitos: graduação completa em Enfermagem, COREN ativo, domínio de anatomia, fisiologia e CID-10, excelente comunicação e disponibilidade para capacitação presencial em Vila Velha/ES. Regime de contratação Pessoa Jurídica (PJ), atuação remota com possibilidade de híbrido.",
  datePosted: "2026-06-01",
  validThrough: "2026-09-30",
  employmentType: "CONTRACTOR",
  jobLocationType: "TELECOMMUTE",
  applicantLocationRequirements: { "@type": "Country", name: "Brasil" },
  jobLocation: {
    "@type": "Place",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Vila Velha",
      addressRegion: "ES",
      addressCountry: "BR",
    },
  },
  hiringOrganization: {
    "@type": "Organization",
    name: BRAND.name,
    sameAs: SITE_URL,
    logo: `${SITE_URL}/previsa-logo.png`,
  },
  applicationContact: { "@type": "ContactPoint", email: APPLY_EMAIL },
  directApply: true,
  url: `${SITE_URL}${JOB_PATH}`,
};

export const useJobSEO = () => {
  usePageSEO({ path: JOB_PATH, title: SEO_TITLE, description: SEO_DESC });

  useEffect(() => setJsonLd("job-posting-schema", jobPostingSchema), []);
};
